/**
 * Created by HYL.
 * 大屏相关api
 */
import * as API from './'

export default {
  
  datas: params => {
    return API.GET('/api/screen/datas', params)
  },
  getProjectDeviceTotal:params=>{
    return API.GET('/api/project/getProjectDeviceTotal', params)
  },
  getDeviceList:params=>{
    return API.GET("/api/screen/getDeviceList",params)
  },
  getDeviceType:params=>{
    return API.GET("/api/screen/getDeviceType",params)
  }
}



// WEBPACK FOOTER //
// ./src/api/api_screen.js